// Generated by scripts/build-ui-icons.mjs.
export { Check as default } from "../ui/glyphs-2";
